import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';

export const ExaminedLinkExams = (props: { examinedId: string }) => {
  const nav = useNavigation();

  return (
    <OverlayTrigger overlay={<Tooltip>Badania badanego</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          void nav.examsExamined(props.examinedId);
        }}
        variant="btn-info"
      >
        <Icon.CardList />
      </Button>
    </OverlayTrigger>
  );
};
